package com.arena_web.data.dto

import kotlinx.serialization.Serializable

@Serializable
data class ClubScheduleDto(
    val workingHours: List<WorkingHoursDto>,
    val exceptions: List<ScheduleExceptionDto>
)

@Serializable
data class WorkingHoursDto(
    val id: String,
    val dayOfWeek: Int,
    val openTime: String,
    val closeTime: String,
    val isClosed: Boolean = false
)

@Serializable
data class ScheduleExceptionDto(
    val id: String,
    val exceptionDate: String,
    val openTime: String? = null,
    val closeTime: String? = null,
    val isClosed: Boolean = false,
    val reason: String? = null,
    val createdAt: String
)

@Serializable
data class UpdateWorkingHoursRequest(
    val entries: List<WorkingHoursEntry>
)

@Serializable
data class WorkingHoursEntry(
    val dayOfWeek: Int,
    val openTime: String,
    val closeTime: String,
    val isClosed: Boolean = false
)

@Serializable
data class CreateScheduleExceptionRequest(
    val exceptionDate: String,
    val openTime: String? = null,
    val closeTime: String? = null,
    val isClosed: Boolean = false,
    val reason: String? = null
)

@Serializable
data class UpdateScheduleExceptionRequest(
    val exceptionDate: String? = null,
    val openTime: String? = null,
    val closeTime: String? = null,
    val isClosed: Boolean? = null,
    val reason: String? = null
)

@Serializable
data class FieldPricingDto(
    val id: String,
    val fieldId: String,
    val dayType: String,
    val timeSlot: String,
    val pricePerHour: String
)

@Serializable
data class UpdateFieldPricingRequest(
    val entries: List<PricingEntry>
)

@Serializable
data class PricingEntry(
    val dayType: String,
    val timeSlot: String,
    val pricePerHour: String
)

@Serializable
data class ClubServiceDto(
    val id: String,
    val clubId: String,
    val name: String,
    val description: String? = null,
    val price: String,
    val isEnabled: Boolean = true,
    val createdAt: String,
    val updatedAt: String
)

@Serializable
data class CreateClubServiceRequest(
    val name: String,
    val description: String? = null,
    val price: String
)

@Serializable
data class UpdateClubServiceRequest(
    val name: String? = null,
    val description: String? = null,
    val price: String? = null,
    val isEnabled: Boolean? = null
)

@Serializable
data class UpdateClubAmenitiesRequest(
    val amenities: List<String>
)
